import { AGENT_ACTION_BUTTON_FIELDS } from "../../../../../../agents.constants";

export interface AgentDetailActionButtonState {
    showCreateDownline: boolean;
    disableCreateDownline: boolean;
    showResendInvite: boolean;
}

export const getAgentDetailActionButtonState = (
    hiddenActionButtons: string[] | undefined,
    restrictedActionButtons: string[] | undefined
): AgentDetailActionButtonState => {
    const hidden = hiddenActionButtons ?? [];
    const restricted = restrictedActionButtons ?? [];
    const isCreateHidden = hidden.includes(AGENT_ACTION_BUTTON_FIELDS.CREATE_DOWNLINE);
    const isResendHidden = hidden.includes(AGENT_ACTION_BUTTON_FIELDS.RESEND_INVITE);
    const isCreateRestricted = restricted.includes(AGENT_ACTION_BUTTON_FIELDS.CREATE_DOWNLINE);
    const isResendRestricted = restricted.includes(AGENT_ACTION_BUTTON_FIELDS.RESEND_INVITE);

    return {
        showCreateDownline: !isCreateHidden,
        disableCreateDownline: !isCreateHidden && isCreateRestricted,
        showResendInvite: !isResendHidden && !isResendRestricted,
    };
};
